import { ChangeDetectionStrategy, Component, computed, inject, model } from '@angular/core'
import { MenubarModule } from 'primeng/menubar'
import { DrawerModule } from 'primeng/drawer'
import { ButtonModule } from 'primeng/button'
import { MenuModule } from 'primeng/menu'
import { Ripple } from 'primeng/ripple'
import { OverrideStateService } from '@services/override-state.service'
import { ToolbarService } from '@app/layout/toolbar/services/toolbar.service'
import { RouterModule } from '@angular/router'

@Component({
  selector: 'albert-toolbar',
  standalone: true,
  imports: [MenubarModule, DrawerModule, ButtonModule, MenuModule, Ripple, RouterModule],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarComponent {
  public readonly toolbarDrawerVisible = model(false)
  private readonly state = inject(OverrideStateService)
  private readonly toolbarService = inject(ToolbarService)

  public readonly items = computed(() =>
    this.toolbarService.getFilteredItems(
      () => this.state.toggle(),
      () => this.closeToolbarDrawer()
    )
  )

  /** Top-level groups expand and collapse like an accordion in the mobile drawer. */
  public readonly mobileItems = computed(() =>
    this.items().map(item => ((item.items?.length ?? 0) > 0 ? { ...item, toggleable: true } : item))
  )

  public closeToolbarDrawer(): void {
    this.toolbarDrawerVisible.set(false)
  }
}
